module.exports = __webpack_public_path__ + "assets/img/b1ada250611cd96accfce518f495deb2.svg";